import UpdateUserReferralSegment from './Update';

export default UpdateUserReferralSegment;
